import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import Expander from "../../../../components/Expander";
import { PATHWAYS } from "./constants";
import HelperText from "../../../../components/atoms/HelperText";

const displayPathwayRow = (item, url, title) => {
  let row = null;
  if (Array.isArray(item) && item.length > 0) {
    row = (
      <tr key={title}>
        <td>
          <a href={getVarsoUrl(url)} target="_blank">
            {title}
          </a>
        </td>
        <td>
          <Expander showMore="10">
            {item.map((it, i) => {
              return (
                <span key={i}>
                  {it}
                  {i < item.length - 1 ? ", " : ""}
                </span>
              );
            })}
          </Expander>
        </td>
      </tr>
    );
  }
  return row;
};

const Pathways = ({ item }) => {
  const { gene_symbol: geneSymbol } = item;
  const keggUrl = `http://www.genome.jp/dbget-bin/www_bfind_sub?mode=bfind&max_hit=1000&dbkey=hsa&keywords=${geneSymbol}`;
  const biocartaUrl =
    "http://www.openbioinformatics.org/gengen/tutorial_calculate_gsea.html";
  const consensusUrl = "http://cpdb.molgen.mpg.de/";
  const uniprotUrl = `https://www.uniprot.org/uniprot/?query=${geneSymbol}&fil=organism%3A%22Homo+sapiens+%28Human%29+%5B9606%5D%22&sort=score`;

  const urls = {
    BioCarta: biocartaUrl,
    UniProt: uniprotUrl,
    Consensus: consensusUrl,
  };

  let pathwaysTable = {};
  const pathwaysTableBody = [];
  let row = null;

  const header = (
    <thead>
      <tr>
        <th width="20%">Source</th>
        <th width="80%">Pathways</th>
      </tr>
    </thead>
  );

  // Zip KEGG [id], [full] together in a link.
  const kegg = [];
  if (item.kegg && Array.isArray(item.kegg.full)) {
    for (let j = 0; j < item.kegg.full.length; j++) {
      if (item.kegg.full[j]) {
        kegg.push(
          <span key={j}>
            <a
              target="_blank"
              href={getVarsoUrl(
                `http://www.genome.jp/dbget-bin/www_bget?${item.kegg.id[j]}`
              )}
            >
              {item.kegg.full[j]}
            </a>
            {j < item.kegg.full.length - 1 && ", "}
          </span>
        );
      }
    }
  }

  if (kegg?.length > 0) {
    row = (
      <tr key="kegg">
        <td>
          <a href={getVarsoUrl(keggUrl)} target="_blank">
            KEGG
          </a>{" "}
          <HelperText fieldDescriptionKey="KEGG" />
        </td>
        <td>{kegg}</td>
      </tr>
    );
    pathwaysTableBody.push(row);
  }

  let pathwayRow = null;

  for (const pathwayKey in PATHWAYS) {
    const itemKey = PATHWAYS[pathwayKey];
    pathwayRow = displayPathwayRow(item[itemKey], urls[pathwayKey], pathwayKey);
    pathwaysTableBody.push(pathwayRow);
  }

  pathwaysTable = (
    <table className="varsome-table">
      {header}
      <tbody>{pathwaysTableBody}</tbody>
    </table>
  );

  const res = (
    <div style={{ marginTop: "1rem" }}>
      <div>
        <h5>Pathways</h5>
        {pathwaysTable}
      </div>
    </div>
  );

  return res;
};

const { shape } = PropTypes;

Pathways.propTypes = {
  item: shape({}),
};

Pathways.defaultProps = {
  item: null,
};
export default Pathways;
